export const environment = {
  'production': true,
  'environmentURL': 'https://irishpassportservice.council.bookingbug.com',
  'elavonURL': 'https://pay.elavonpaymentgateway.com/pay',
  'redirectURL': 'https://urgentpassportappointment.dfa.ie/checkPayment',
  'jwtURL': 'https://zlbaw4f6nctzip7zo5ta545buy0xakdm.lambda-url.eu-west-1.on.aws/',
  'paymentCallBackURL': 'https://3gvlgnl22okz3s2cat6xhvu5ay0ssgcx.lambda-url.eu-west-1.on.aws/',
  'apiToken': 'd9a8ae8f05419f520d443bacec2a862163821d05ce1e31678e873e70106e16be'
};
